import { FaLinkedin } from "react-icons/fa";

import { COMPANY_INFO, LOGO_SVG } from '../constants';

export default function LinkedInBadge() {
  return (
    <a
      href={COMPANY_INFO.social.linkedin}
      aria-label="LinkedIn"
      target="_blank"
      rel="noreferrer"
      className="inline-flex items-center gap-2"
    >
      <FaLinkedin aria-hidden size={20} />
    </a>
  );
}
